
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { toast } from "@/hooks/use-toast";
import ActivityImage from "./activity-card/ActivityImage";
import ActivityContent from "./activity-card/ActivityContent";
import ActivityBookingDialog from "./activity-card/ActivityBookingDialog";
import { ActivityCardProps } from "./activity-card/types";
import { useAnalytics } from "@/hooks/use-analytics";

const ActivityCard = ({ 
  title, 
  description, 
  imageUrl, 
  imageUrls = [],
  price, 
  currency,
  bookingUrl,
  rating,
  numberOfRatings,
  type = "activity" // New prop to distinguish between activity and food
}: ActivityCardProps) => {
  const [showBookingDialog, setShowBookingDialog] = useState(false);
  const { trackEvent } = useAnalytics();
  
  console.debug('ActivityCard Props:', {
    title,
    imageUrl,
    imageUrlsLength: imageUrls?.length,
    imageUrls,
    bookingUrl,
    type
  });

  const handleBookingClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    console.debug('Processing booking click:', bookingUrl);
    console.debug('Card type:', type);
    
    // Track the booking action
    // Convert price to number for analytics tracking (if it's a numeric value)
    const priceValue = typeof price === 'string' && !isNaN(parseFloat(price)) 
      ? parseFloat(price) 
      : undefined;
      
    trackEvent(
      "Discover", 
      `${type}_booking_click`, 
      `${title} - Price: ${price} ${currency}`,
      priceValue
    );
    
    if (!bookingUrl.startsWith('http')) {
      console.warn('URL appears to be missing protocol:', bookingUrl);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Invalid booking URL. Please try again."
      });
      
      trackEvent(
        "Error", 
        "invalid_booking_url", 
        `Invalid URL: ${bookingUrl} for ${title}`
      );
      return;
    }
    
    // Open the URL directly in the browser for all types (both food and activity)
    window.open(bookingUrl, '_blank');
  };

  return (
    <>
      <Card className="w-full hover:shadow-lg transition-shadow" onClick={handleBookingClick}>
        <div className="md:flex">
          <ActivityImage 
            imageUrl={imageUrl} 
            imageUrls={imageUrls} 
            title={title} 
          />
          <ActivityContent 
            title={title}
            description={description}
            rating={rating}
            type={type}
            currency={currency}
            numberOfRatings={numberOfRatings}
            price={price}
            bookingUrl={bookingUrl}
            onBookingClick={handleBookingClick}
          />
        </div>
      </Card>
      
      {/* We no longer need the booking dialog since we're opening links directly in the browser */}
    </>
  );
};

export default ActivityCard;
